export const SEARCHFORM_TRANSLATION_KEYS = {
    // date-picker
    startDateLabel: 'datepicker.startDateLabel',
    endDateLabel: 'datepicker.endDateLabel',
    modalTitleStartDateMessage: 'datepicker.modalTitleStartDateMessage',
    modalTitleEndDateMessage: 'datepicker.modalTitleEndDateMessage',
    clearButtonLabel: 'datepicker.clearButtonLabel',
    closeButtonLabel: 'datepicker.closeButtonLabel',
    continueButtonLabel: 'datepicker.continueButtonLabel',
    selectDateHintMessage: 'datepicker.selectDateHintMessage',
    nightsText: 'datepicker.nightsText',

    // guest-picker
    separatorText: 'guestpicker.separatorText',
    adultText: 'guestpicker.adultText',
    adultsText: 'guestpicker.adultsText',
    zeroAdultsText: 'guestpicker.zeroAdultsText',
    ageSelectSubtitle: 'guestpicker.ageSelectSubtitle',
    ageSelectTitle: 'guestpicker.ageSelectTitle',
    ageSelectTitleSingular: 'guestpicker.ageSelectTitleSingular',
    childText: 'guestpicker.childText',
    childrenText: 'guestpicker.childrenText',
    zeroChildrenText: 'guestpicker.zeroChildrenText',
    guestText: 'guestpicker.guestText',
    guestsText: 'guestpicker.guestsText',
    petsText: 'guestpicker.petsText',
    onlyPetsText: 'guestpicker.onlyPetsText',
    label: 'guestpicker.label',
    modalTitle: 'guestpicker.modalTitle',
    petLabel: 'guestpicker.petLabel',
    petNoLabel: 'guestpicker.petNoLabel',
    petYesLabel: 'guestpicker.petYesLabel',
    petMessage: 'guestpicker.petMessage',
    applyButtonLabel: 'guestpicker.applyButtonLabel',

    // Destination placeholder
    errorMessageText: 'typeahead.errorMessageText',
    noResultsFoundMessage: 'typeahead.noResultsFoundMessage',
    placeholderMessage: 'typeahead.placeholderMessage',
    whereLabel: 'typeahead.whereLabel',

    // submit button
    checkAvailabilityLabelText: 'submitButton.checkAvailabilityLabelText',
    searchLabelText: 'submitButton.searchLabelText',

    // details-modal
    titleMessage: 'detailsModal.titleMessage',
};